
import React from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';

// Company logos data with the uploaded image paths
const companyLogos = [
  { name: 'DataAxle', src: '/lovable-uploads/DataAxle.png' },
  { name: 'IQVIA', src: '/lovable-uploads/IQVIA.png' },
  { name: 'JFrog', src: '/lovable-uploads/JFrog.png' },
  { name: 'Target', src: '/lovable-uploads/Target.png' },
  { name: 'Paytm', src: '/lovable-uploads/Paytm.png' },
  { name: 'Fractal', src: '/lovable-uploads/Fractal.png' },
];

const testimonials = [
  {
    quote: "Been following Nikunj and Cutshort for years. Their ideas and tips are always bang on",
    name: "Winston A de Rosario",
    title: "Global Head of People & Culture at Silq"
  },
  {
    quote: "Cutshort always has the best insights on the indian tech talent market. Their ideas helped us hire top talent immensely when we were setting up our India Engineering Centre",
    name: "Harini Ambrose",
    title: "HR Manager at Biofourmis.com"
  }
];

const NewsletterTestimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-neutral-light/30">
      <div className="container px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12">Read by 15000+ recruiters and hiring managers</h2>
          
          {/* Company Logos Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 md:gap-10 mb-16">
            {companyLogos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                <img 
                  src={logo.src} 
                  alt={`${logo.name} logo`} 
                  className="h-12 md:h-14 w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          
          {/* Testimonials */}
          <Carousel className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index}>
                  <div className="bg-white p-8 rounded-xl shadow-sm text-left">
                    <p className="text-lg text-secondary-dark mb-6 italic">"{testimonial.quote}"</p>
                    <div>
                      <p className="font-semibold">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.title}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="left-2 absolute" />
            <CarouselNext className="right-2 absolute" />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default NewsletterTestimonials;

